<template>
  <div class="pa-4" style="width: 100%; min-height: 80vh;">
    <v-card class="elevation-1">
      <v-card-title class="headline primary white--text py-3 px-4 d-flex align-center">
        <v-icon left dark>mdi-undo-variant</v-icon>
        Refund Report
        <v-spacer></v-spacer>
        <v-btn icon dark @click="loadTransactions" :loading="isLoading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <!-- Search and Actions Filter -->
        <v-row dense class="mb-3 align-center">
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="searchQuery"
              prepend-inner-icon="mdi-magnify"
              label="Search by Customer, Description or ID"
              dense
              outlined
              clearable
              hide-details
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="caption grey--text text--darken-1">
            Total Records: <strong>{{ filteredRefunds.length }}</strong>
          </v-col>
        </v-row>

        <!-- Loading State -->
        <div v-if="isLoading" class="text-center py-8">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
          <div class="mt-2 subtitle-2 grey--text">Loading refund transactions...</div>
        </div>

        <!-- Empty State -->
        <v-alert v-else-if="filteredRefunds.length === 0" type="info" outlined dense class="my-4">
          No refund records found.
        </v-alert>

        <!-- Refund Records Table -->
        <v-simple-table v-else fixed-header height="650px" class="elevation-1">
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-3">
                <th class="text-left font-weight-bold">Trans ID</th>
                <th class="text-left font-weight-bold">Invoice #</th>
                <th class="text-left font-weight-bold">Date</th>
                <th class="text-left font-weight-bold">Customer ID</th>
                <th class="text-left font-weight-bold">Customer Name</th>
                <th class="text-left font-weight-bold">Description</th>
                <th class="text-left font-weight-bold">Method</th>
                <th class="text-right font-weight-bold">Refund Amount</th>
                <th class="text-right font-weight-bold">Current Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredRefunds" :key="item.id" class="hover-row">
                <td class="font-weight-medium">#{{ item.id }}</td>
                <td>
                  <span v-if="item.invoiceId" class="primary--text font-weight-medium">
                    #{{ item.invoiceId }}
                  </span>
                  <span v-else class="grey--text">-</span>
                </td>
                <td>{{ formatDate(item.createdAt) }}</td>
                <td>{{ (item.customer && item.customer.id) || item.customerId || '-' }}</td>
                <td class="font-weight-medium">
                  {{ (item.customer && item.customer.name) || '-' }}
                </td>
                <td>{{ item.description || '-' }}</td>
                <td>
                  <v-chip x-small color="info" outlined>
                    {{ item.paymentMethod || getPaymentMethod(item) }}
                  </v-chip>
                </td>
                <td class="text-right font-weight-bold error--text">
                  £{{ formatCurrency(item.amountCredit || item.amountDebit || item.amount) }}
                </td>
                <td class="text-right font-weight-medium">
                  £{{ formatCurrency(item.currentBalance) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ledgerService } from './../../services/'
import moment from 'moment'

export default {
  name: 'RefundReport',
  data: () => ({
    isLoading: true,
    refundReportData: [],
    searchQuery: '',
  }),

  computed: {
    filteredRefunds () {
      if (!this.refundReportData || !Array.isArray(this.refundReportData)) return []
      if (!this.searchQuery || !this.searchQuery.trim()) return this.refundReportData

      const q = this.searchQuery.trim().toLowerCase()
      return this.refundReportData.filter(item => {
        const id = String(item.id || '')
        const invoiceId = String(item.invoiceId || '')
        const custName = (item.customer && item.customer.name ? item.customer.name : '').toLowerCase()
        const custId = String((item.customer && item.customer.id) || item.customerId || '')
        const desc = (item.description || '').toLowerCase()
        return id.includes(q) || invoiceId.includes(q) || custName.includes(q) || custId.includes(q) || desc.includes(q)
      })
    }
  },

  methods: {
    loadTransactions () {
      this.isLoading = true
      ledgerService.getRefundReport()
        .then(refundReport => {
          this.refundReportData = refundReport || []
          this.isLoading = false
        })
        .catch(err => {
          console.error('Failed to load refund report:', err)
          this.refundReportData = []
          this.isLoading = false
        })
    },

    formatDate (dateStr) {
      if (!dateStr) return '-'
      return moment(dateStr).format('YYYY-MM-DD')
    },

    formatCurrency (val) {
      if (val == null || isNaN(val)) return '0.00'
      return parseFloat(val).toFixed(2)
    },

    getPaymentMethod (item) {
      if (item.card && item.card > 0) return 'Card'
      if (item.bankDeposit && item.bankDeposit > 0) return 'Bank Deposit'
      if (item.cheque && item.cheque > 0) return 'Cheque'
      return 'Cash'
    }
  },

  mounted () {
    this.loadTransactions()
  }
}
</script>

<style scoped>
.hover-row:hover {
  background-color: #f0f7ff !important;
}
</style>